// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"667":"b7fb0638","977":"97046853"}[chunkId] + ".chunk.js";
};